module.exports = __webpack_public_path__ + "img/192.0d20f58b.svg";